import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { HeaderComponent } from 'src/app/common-components/header/header.component';

 import { ColDef, GridOptions } from 'ag-grid-community';
import { AgGridModule } from 'ag-grid-angular';
import { BASE_AG_GRID_OPTIONS } from 'src/app/service/common-config';
@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.css'],
  standalone: true,
  imports: [HeaderComponent, FormsModule, CommonModule,AgGridModule]
})
export class DisclaimerComponent implements    OnInit {
gridOptions: GridOptions = {
  pagination: true,
  paginationPageSize: 15,
  rowSelection : 'single',
    suppressColumnVirtualisation: true,
  suppressDragLeaveHidesColumns: true,
...BASE_AG_GRID_OPTIONS,
};

  isShow: boolean;
  @Output() onAcceptDiscalimer   = new EventEmitter<any>();
  @Output() closeModal   = new EventEmitter<any>();
  constructor(    private router: Router,) { }

  ngOnInit(): void {
  }


  Accept() {
    this.onAcceptDiscalimer.emit();
  }

  close() {
    this.closeModal.emit();
  }

}
